import axios from "axios";
import React, {
  useState,
  useImperativeHandle,
  forwardRef,
} from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  setOrderId,
  saveTrnsactionDetails,
  setPaytmDataInStore,
} from "../../redux/payment_gateway/action";
import "./PaytmPayment.scss";
import { url_299 } from "../api_services";
import { extractOrderId, savePendingOrderId } from "./paytmHelpers";
import EmailUpdateModal from "../../containers/logged_user_components/user_edit_profile/user_edit_profile_content_component/update_email/EmailUpdateModal";
import ProfileAddressUpdateModal from "../../containers/logged_user_components/user_edit_profile/user_edit_profile_content_component/update_address/ProfileAddressUpdateModal";
import uiActions from "../../redux/ui/action";
import {
  getMissingProfileFieldLabels,
} from "../profilePaymentFields";

const PaytmPayment = forwardRef((props, ref) => {
  const {
    packageDetails,
    amount,
    paymentAction,
    saveTransactionAction,
    setPaytmDataInStore,
    startLoading,
    finishLoading,
    userData,
    buttonText,
    buttonClass,
    is_amrit,
    addon_products,
    orderId,
    couponCode,
  } = props;

  const [emailStatus, setEmailStatus] = useState({
    showEmailModal: false,
    emailUpdated: false,
  });

  const [profileModalStatus, setProfileModalStatus] = useState({
    showProfileModal: false,
    missingFields: [],
  });

  const [isInitiating, setIsInitiating] = useState(false);
  const history = useHistory();

  const handleOpen = () => {
    setEmailStatus((prevState) => ({
      ...prevState,
      showEmailModal: true,
    }));
  };

  const handleClose = () => {
    setEmailStatus((prevState) => ({
      ...prevState,
      showEmailModal: false,
    }));
  };

  const handleOpenProfileModal = (missingFields) => {
    setProfileModalStatus({
      showProfileModal: true,
      missingFields,
    });
  };

  const handleCloseProfileModal = () => {
    setProfileModalStatus({
      showProfileModal: false,
      missingFields: [],
    });
  };

  const { batch_id, user_id } = userData || {};
  const addonProductsIds = addon_products
    ? addon_products.map((pkg) => pkg.package_id).join(",")
    : "";

  const updateOrderAndTransactionState = (responseData) => {
    const orderIdFromResponse =
      responseData?.order_id || responseData?.Order_Id || "";
    paymentAction(orderIdFromResponse);
    setPaytmDataInStore(responseData);
    saveTransactionAction({
      course_id: userData?.targets?.[0]?.course_id || "",
      batch_id,
      package_id: packageDetails?.package_id ? packageDetails?.package_id : "",
      txn_amount: amount,
      txn_discount_amount: packageDetails?.discount ? packageDetails.discount : "",
      txn_date: new Date().toISOString().replace("T", " ").substring(0, 19),
      package_duration: packageDetails?.duration ? packageDetails.duration : "",
      txnid: orderIdFromResponse,
      addon_products: addonProductsIds,
    });
    return responseData;
  };

  const buildInitiatePayload = () => {
    const productId = packageDetails?.package_id || packageDetails?.p_id;

    const payload = {
      user_id,
      product_id: productId,
      platform: "WEB",
    };

    if (amount !== undefined && amount !== null && amount !== "") {
      payload.total_price = String(amount);
    }

    if (orderId && couponCode) {
      payload.order_id = orderId;
    }

    if (couponCode) {
      payload.coupon_code = couponCode;
    }

    return payload;
  };

  const initiatePaytm = async () => {
    const payload = buildInitiatePayload();
    const response = await axios.post(url_299, payload);
    if (response.data.status === 200) {
      const responseData = response.data?.data || response.data;
      return updateOrderAndTransactionState(responseData);
    }
    return null;
  };

  const getPaytmData = async () => null;

  const navigateToPaymentStatusPage = (paytmData) => {
    const orderIdValue = extractOrderId(paytmData);
    if (!orderIdValue) return false;

    savePendingOrderId(orderIdValue);
    history.push(
      `/payment_gateway?order_id=${encodeURIComponent(
        orderIdValue
      )}&await_payment=1`
    );
    return true;
  };

  const stopPaymentLoading = () => {
    setIsInitiating(false);
    finishLoading();
  };

  const initiateAndPay = async (updatedUser) => {
    if (isInitiating) return;

    const profileOverride =
      updatedUser &&
      typeof updatedUser === "object" &&
      updatedUser.user_id
        ? updatedUser
        : undefined;

    if (!validateProfileData(profileOverride)) return;

    if (!user_id) return;

    const productId = packageDetails?.package_id || packageDetails?.p_id;
    if (!productId) return;

    setIsInitiating(true);
    startLoading();

    try {
      const localPaytmData = await initiatePaytm();
      if (!localPaytmData) {
        stopPaymentLoading();
        return;
      }
      navigateToPaymentStatusPage(localPaytmData);
      stopPaymentLoading();
    } catch (err) {
      stopPaymentLoading();
    }
  };

  useImperativeHandle(ref, () => ({
    getPaytmData,
  }));

  const validateProfileData = (updatedUser) => {
    if (is_amrit || packageDetails?.is_subscribe) return true;

    const profile = updatedUser || userData || {};
    const missingFields = getMissingProfileFieldLabels(profile);

    if (missingFields.length > 0) {
      const nonEmailMissing = missingFields.filter((field) => field !== "email");

      if (missingFields.includes("email") && nonEmailMissing.length === 0) {
        handleOpen();
        return false;
      }

      handleOpenProfileModal(missingFields);
      return false;
    }
    window.onbeforeunload = null;
    return true;
  };

  const payButtonLabel = isInitiating
    ? "Processing..."
    : buttonText?.length !== 0
    ? buttonText
    : "Pay Now";

  return (
    <>
      <button
        type="button"
        onClick={() => initiateAndPay()}
        className={buttonClass?.length !== 0 ? buttonClass : "pay_now"}
        disabled={isInitiating}
      >
        {payButtonLabel}
      </button>
      {emailStatus?.showEmailModal && (
        <EmailUpdateModal
          isEmailModalOpen={emailStatus.showEmailModal}
          closeEmailModal={handleClose}
        />
      )}
      {profileModalStatus.showProfileModal && (
        <ProfileAddressUpdateModal
          isModalOpen={profileModalStatus.showProfileModal}
          closeModal={handleCloseProfileModal}
          missingFields={profileModalStatus.missingFields}
          onProfileUpdated={(updatedUser) => initiateAndPay(updatedUser)}
        />
      )}
    </>
  );
});

const mapStateToProps = (state) => {
  return {
    token: state.auth.authToken,
    tokenType: state.auth.authType,
    userData: state.auth.user,
    orderId: state.paymentReducer.orderId,
    user_id: state.auth.user.user_id,
    is_amrit: state.auth.user.is_amrit,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    paymentAction: (payload) => dispatch(setOrderId(payload)),
    saveTransactionAction: (payload) =>
      dispatch(saveTrnsactionDetails(payload)),
    setPaytmDataInStore: (payload) =>
      dispatch(setPaytmDataInStore(payload)),
    startLoading: () => dispatch(uiActions.startLoading()),
    finishLoading: () => dispatch(uiActions.finishLoading()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaytmPayment);
